import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedQueryModel } from 'src/app/shared/models/paginatedQuery.model';
import { VenueModel } from 'src/app/shared/models/venue.model';
import { environment } from 'src/environments/environment';
import { ErrorResponse, SuccessResponse } from 'src/app/shared/interfaces/response.interface';
// import { QueryParamsHandling } from '@angular/router';
// import { IUrlQueryParams } from 'src/app/shared/interfaces/url-navigation.interface';
import { VenueType } from '../interfaces/venue-type.interface';
// import { HIDE_LOADER } from 'src/app/shared/interceptors/loader.interceptor';

@Injectable({
  providedIn: 'root',
})
export class VenuesService {
  private apiRoot = '/api/venues';

  constructor(private http: HttpClient) {}

  public getAll(page?: number, searchParams?: any): Observable<SuccessResponse | ErrorResponse> {
    let params = new HttpParams();
    params = params.set('related', 'venuetype');
    if (page) {
      params = params.set('page', page);
    }
    if (searchParams && searchParams.name) {
      params = params.set('name', searchParams.name);
    }
    if (searchParams && searchParams.key) {
      params = params.set('key', searchParams.key);
    }
    if (searchParams && searchParams.country) {
      params = params.set('country', searchParams.country);
    }
    if (searchParams && searchParams.city) {
      params = params.set('city', searchParams.city);
    }
    if (searchParams && searchParams.venuetype) {
      params = params.set('venuetype', searchParams.venuetype);
    }
    if (searchParams && searchParams.order) {
      params = params.set('order', searchParams.order);
    }
    if (searchParams && searchParams.direction) {
      params = params.set('direction', searchParams.direction);
    }
    return this.http.get<any>(environment.apiVenuesUrl + `${this.apiRoot}`, { params });
  }

  public list(fields: String[]): Observable<SuccessResponse | ErrorResponse> {
    let query = '';
    if (fields.length) {
      query = `?fields=${fields.join()}`;
    }
    return this.http.get<any>(environment.apiVenuesUrl + `${this.apiRoot}/list${query}`);
  }

  public get(venueId, fields?: string, related?: string): Observable<any> {
    let qs: string = '';
    if (fields) qs += '?fields=' + fields; // id,key,name,province,region,address,city,number,country
    if (related) qs === '' ? (qs += '?related=' + related) : (qs += '&related=' + related); // configurations,venuemanagers,venuetype
    return this.http.get<any>(environment.apiVenuesUrl + `${this.apiRoot}/${venueId}${qs}`);
  }

  public getByKey(key: string) {
    return this.http.get<any>(environment.apiVenuesUrl + `${this.apiRoot}/key/${key}`);
  }

  public getVenuesByFieldsFromKeys(keys: string[]): Observable<any> {
    let queryParams = 'fields=name,country,city&related=venuetype';
    const formData: FormData = new FormData();
    keys.forEach(key => formData.append('keys[]', key));
    return this.http.post(environment.apiVenuesUrl + `${this.apiRoot}/key?${queryParams}`, formData);
  }

  public getByKeyList(body: { keys: string[] }, fields?: string, related?: string, context?: HttpContext) {
    let params = new HttpParams();
    params = fields ? params.set('fields', fields) : params;
    params = related ? params.set('related', related) : params;

    return this.http.post<SuccessResponse<VenueModel[]> | ErrorResponse>(
      environment.apiVenuesUrl + `${this.apiRoot}/key`,
      body,
      { context, params: params }
    );
  }

  public getByField(field: string, value: string) {
    const encodedValue = encodeURIComponent(value);
    return this.http.get<any>(
      environment.apiVenuesUrl + `${this.apiRoot}/filter/?field=${field}&value=${encodedValue}`
    );
  }

  public create(body: any): Observable<any> {
    return this.http.post<any>(environment.apiVenuesUrl + `${this.apiRoot}`, body);
  }

  public update(venueId: number, body: any): Observable<any> {
    return this.http.patch<any>(environment.apiVenuesUrl + this.apiRoot + `/${venueId}`, body);
  }

  public getMultipleVenuesByKeys(keys: any, fields: any) {
    let queryParams = '';
    keys.map(key => (queryParams += '&key=' + key));
    fields.map(field => (queryParams += '&field=' + field));
    return this.http.get<any>(environment.apiVenuesUrl + `/public/venues?${queryParams}`);
  }

  public getVenuesByClientKey(key: string): Observable<PaginatedQueryModel<VenueModel>> {
    // TODO: falta implementar la llamada real a la api cuando este hecha
    // De momento hay data fake como si fuera real, para solo tener que implementar
    // return this.http.get<PaginatedQueryModel<VenueModel>>(`url y key`)
    return new Observable(observer => {
      const data: PaginatedQueryModel<VenueModel> = {
        meta: {
          total: 3904,
          per_page: 25,
          current_page: 1,
          last_page: 157,
          first_page: 1,
          first_page_url: '/?page=1',
          last_page_url: '/?page=157',
          next_page_url: '/?page=2',
          previous_page_url: null,
        },
        data: [
          {
            id: 4073,
            key: 'V-e89213b3-1533-4b26-a329-a43080f0af46',
            venuetype_id: 6,
            name: 'Bosque Multicines - Sala 08',
            capacity: 0,
            multipurpose: true,
            itinerant: true,
            vip: false,
            city: 'Barcelona',
            address: 'Rambla de Prat',
            number: '16',
            province: 'Barcelona',
            region: 'Cataluña',
            country: 'España',
            countryCode: 'ES',
            zipcode: '08012',
            coordinatesGooglemaps: {
              lat: 41.40162979999999,
              long: 2.1517221,
            },
            construction_year: '',
            web: '',
            roof: 'openair',
            venuetype: {
              id: 6,
              name: 'circuito de carreras',
            },
          },
          {
            id: 4072,
            key: 'V-e89213b3-1533-4b26-a329-a43080f4af46',
            venuetype_id: 6,
            name: 'Bosque Multicines - Sala 07',
            capacity: 0,
            multipurpose: false,
            itinerant: false,
            vip: false,
            city: 'Barcelona',
            address: 'Rambla de Prat',
            number: '16',
            province: 'Barcelona',
            region: 'Cataluña',
            country: 'España',
            countryCode: 'ES',
            zipcode: '08012',
            coordinatesGooglemaps: {
              lat: 41.40162979999999,
              long: 2.1517221,
            },
            construction_year: '',
            web: '',
            roof: 'openair',
            venuetype: {
              id: 6,
              name: 'circuito de carreras',
            },
          },
          {
            id: 4071,
            key: 'V-e89213b3-1533-4b26-a329-a43080f0af43',
            venuetype_id: 6,
            name: 'Bosque Multicines - Sala 06',
            capacity: 0,
            multipurpose: false,
            itinerant: false,
            vip: false,
            city: 'Barcelona',
            address: 'Rambla de Prat',
            number: '16',
            province: 'Barcelona',
            region: 'Cataluña',
            country: 'España',
            countryCode: 'ES',
            zipcode: '08012',
            coordinatesGooglemaps: {
              lat: 41.40162979999999,
              long: 2.1517221,
            },
            construction_year: '',
            web: '',
            roof: 'openair',
            venuetype: {
              id: 6,
              name: 'circuito de carreras',
            },
          },
        ],
      };
      observer.next(data);
      observer.complete();
    });
  }

  public getNumbers(body: { keys: Array<string> }) {
    return this.http.post<any>(environment.apiVenuesUrl + `/api/numbers/venues`, body);
  }

  public getCountries() {
    return this.http.get<any>(environment.apiVenuesUrl + `/api/venues/country`);
  }

  public getCities() {
    return this.http.get<any>(environment.apiVenuesUrl + `/api/venues/city`);
  }

  public getVenuetypes(page?: number): Observable<SuccessResponse | ErrorResponse> {
    let params = new HttpParams();
    if (page) {
      params = params.set('page', page);
    }
    return this.http.get<any>(environment.apiVenuesUrl + `/api/venuetypes`, { params });
  }

  public getVenuetypeById(
    id: number,
    related: string
  ): Observable<SuccessResponse<VenueType & { venues?: VenueModel }> | ErrorResponse> {
    let params = new HttpParams();
    if (related) {
      params = params.set('related', related);
    }
    return this.http.get<any>(environment.apiVenuesUrl + `/api/venuetypes/${id}`, { params });
  }
  public postVenuetypes(body: { name: string }): Observable<SuccessResponse | ErrorResponse> {
    return this.http.post<any>(environment.apiVenuesUrl + `/api/venuetypes`, body);
  }
  public updateVenuetypes(id: number, body: { name: string }): Observable<SuccessResponse<VenueType> | ErrorResponse> {
    return this.http.patch<any>(environment.apiVenuesUrl + `/api/venuetypes/${id}`, body);
  }
  public deleteVenuetypes(id: number): Observable<SuccessResponse<VenueType> | ErrorResponse> {
    return this.http.delete<any>(environment.apiVenuesUrl + `/api/venuetypes/${id}`);
  }
  public getVenueCountriesTotal(): Observable<SuccessResponse | ErrorResponse> {
    return this.http.get<any>(environment.apiVenuesUrl + `/api/venues/country/totals`);
  }

  public getVenueWithTypeExport(
    columns4Venue: string[],
    columns4VenueType: string[]
  ): Observable<Array<Partial<VenueModel>>> {
    let params = new HttpParams();
    columns4Venue.forEach(item => (params = params.append('venueColumn', item)));
    columns4VenueType.forEach(item => (params = params.append('venueTypeColumn', item)));
    return this.http.get<Array<Partial<VenueModel>>>(environment.apiVenuesUrl + `/api/admin/venue/export-to-csv`, {
      params,
    });
  }
}
